// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2C0AV","file":"styles_file__3Hvi9"};